import React from 'react';
import replaceCommaWithDot from '../../../helpers/utils/replaceCommaWithDot';
import EstimationBlock from '../templates/common/estimationBlock';
import SliderControllerBlock from '../templates/common/sliderControllerBlock';

export default function template(context) {
    const calc = context.calc,
      model = calc.state.model;

  const estimationData = [
    {
      label: calc.l10n('CALCULATOR_CREDIT_COST'),
      value: `${replaceCommaWithDot(model.findAverageSum().toLocaleString('uk-UA'))} ${calc.l10n('UAH_ICON')}`,
    },
    {
      label: calc.l10n('CALCULATOR_CREDIT_SUM_NEW_DESIGN'),
      value: `${model.getCreditSum().toLocaleString()} ${calc.l10n('UAH_ICON')}`,
    },
    {
      label: calc.l10n('CALCULATOR_TERMS_USAGE'),
      value: `${model.getTerm().toLocaleString('uk-UA')} ${calc.l10n(model.getDay())}`,
    },
    {
      label: calc.l10n('CALCULATOR_CREDIT_BID'),
      value: `${model.getCreditRate()}${calc.l10n('PERCENT')}`,
    },
    {
      label: calc.l10n('CALCULATOR_CREDIT_COMMISSION'),
      value: `${model.getMonthCommission()}${calc.l10n('PERCENT')}`,
    },
  ];

  return (
    <>
      <div className="calculator-new__top top-calculator-new">
        <div className="top-calculator-new__body">
          <h2 className="top-calculator-new__title">{calc.l10n('CALCULATOR_NEW_TITLE')}</h2>
          <div className="top-calculator-new__base-rate">
            {calc.l10n("CALCULATOR_NEW_CREDIT_LIMIT_BASE_RATE")}
          </div>
        </div>
      </div>
      <div className="calculator-new__bottom">
        <SliderControllerBlock
          title={calc.l10n('CALCULATOR_NEW_CREDIT_LIMIT_CONTROLLER_SUM_TITLE')}
          titleNote={`${calc.l10n('CALCULATOR_NEW_CREDIT_LIMIT_CONTROLLER_SUM_TITLE_NOTE_01')} ${model.getMaxSumEdge().toLocaleString('uk-UA')} ${calc.l10n('CALCULATOR_NEW_CREDIT_LIMIT_CONTROLLER_SUM_TITLE_NOTE_02')}`}
          inputName="creditSum"
          value={model.getCreditSum()}
          currency={calc.l10n('UAH_ICON')}
          min={model.getMinSumEdge()}
          max={model.getMaxSumEdge()}
          step={model.getSumStep()}
          currencyOffset={calc.state.valueWith}
          hiddenValueRef={calc.hiddenValue}
          onInputChange={calc.handleChangeInput}
          onInputBlur={calc.blurChangeInput}
          onRangeChange={calc.handleChange}
          showError={false}
        />
        <SliderControllerBlock
          title={calc.l10n('CALCULATOR_NEW_CREDIT_LIMIT_DESIRED_CREDIT_TERM')}
          inputName="term"
          value={model.getTerm()}
          currency={calc.l10n(model.getDay())}
          min={model.getTerms()[0]}
          max={model.getTerms()[1]}
          step={1}
          currencyOffset={calc.state.valueWidth2}
          hiddenValueRef={calc.hiddenValue2}
          onInputChange={calc.handleChangeInput}
          onInputBlur={calc.blurChangeInput}
          onRangeChange={calc.handleChange}
          showError={false}
        />
        <EstimationBlock
          title={calc.l10n('CALCULATOR_NEW_ESTIMATION_TITLE')}
          items={estimationData}
        />
        <div className='calculator-new__hint-info'>{calc.l10n("CALCULATOR_NEW_CREDIT_LIMIT_HINT_INFO")}</div>
      </div>
    </>
  );
}
